import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';
import { matchedPercentileType } from 'types';


const MatchedPercentileFilter = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const matchedpercentilefilter = JSON.parse(searchParams.get('matchedpercentilefilter') || '[]');

	// const options = matchedpercentilefilterOptionsData;

	const options = Object.values(matchedPercentileType).map(value => ({	
		value,
		label: value.charAt(0).toUpperCase() + value.slice(1),
	}));

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!matchedpercentilefilter?.length}
					placeholder={'Match'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, index) => (
								<Button
									key={index}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: matchedpercentilefilter?.includes(option?.value?.toString())
											? '#7777e71b'
											: 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (matchedpercentilefilter?.includes(option?.value?.toString())) {
											searchParams.set(
												'matchedpercentilefilter',
												JSON.stringify(
													matchedpercentilefilter?.filter((skill: string) => skill !== option?.value?.toString()),
												),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set(
											'matchedpercentilefilter',
											JSON.stringify([...matchedpercentilefilter, option?.value?.toString()]),
										);
										setSearchParams(searchParams);
									}}
								>
									{option?.label}
									{matchedpercentilefilter?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Matched Percentile</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="Completed"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => matchedpercentilefilter?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set(
								'matchedpercentilefilter',
								JSON.stringify(option?.map((option: any) => option?.value?.toString())),
							);
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default MatchedPercentileFilter;
